<template>
  <div class="ftb" ref="tabBox">
    <div class="ftb-selectors" v-if="panes.length > 1">
      <div v-for="p in panes" :key="p.internalName" class="ftb-selector" :data-target="`pane-${p.internalName}`"
        :class="{ selected: p.internalName === initialPaneId, hasItems: p.itemCount > 0, hidden: (p.itemCount === 0 && p.hideWhenEmpty !== 'false')}">
        <a>{{ p.label }}</a>
        <span class="item-count">{{ p.itemCount }}</span>
      </div>
    </div>
    <div class="ftb-panes" ref="tabBoxPanes">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "TabBox",
  props: {
    initialTab: String,
    resultCounts: Object,
  },
  setup() {
    const tabBoxPanes = ref(null);
    return { tabBoxPanes };
  },
  data() {
    return {
      panes: [],
    };
  },
  computed: {
    initialPaneId() {
      let selectedIndex = this.panes.findIndex(
        (x) => x.internalName === this.initialTab
      );
      if (selectedIndex !== -1) {
        return this.panes[selectedIndex].internalName;
      } else {
        return -1;
      }
    },
  },
  watch: {
    resultCounts: {
      deep: true,
      handler(val) {
        this.panes.map((p) => {
          if (val.hasOwnProperty(p.internalName)) {
            p.itemCount = val[p.internalName];
          }
        });
      },
    },
  },
  mounted() {
    this.panes = [];
    const paneEls = this.tabBoxPanes.querySelectorAll(".ftb-pane");
    if (paneEls) {
      paneEls.forEach((p) => {
        this.panes.push({
          label: p.dataset.label,
          internalName: p.dataset.internalName,
          //value: p.value,
          itemCount: p.dataset.itemCount,
          hideWhenEmpty: p.dataset.hideWhenEmpty
        });
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-count {
  margin-left: 10px;
  display: inline-block;
  border-radius: 10px;
  background-color: #aaa;
  font-size: 11px;
  text-shadow: 0 0 1px rgb(0 0 0 / 20%);
  padding: 2px 10px;
  font-weight: 700;
  color: #fff;
  line-height: normal;
  align-self: center;
}

.ftb-selector.selected .item-count,
.ftb-selector:hover .item-count,
.ftb-selector.hasItems .item-count {
  background-color: #666;
}

.ftb-selector.hasItems a {
  color: #323232 !important;
}

.ftb-selectors {
  /*border-bottom: 1px dashed #aaaaaa;*/
}

.ftb-selector.hidden {
  display: none !important;
}
</style>
